import { render, staticRenderFns } from "./ChattingBlock.vue?vue&type=template&id=3a2da870&scoped=true"
import script from "./ChattingBlock.vue?vue&type=script&lang=js"
export * from "./ChattingBlock.vue?vue&type=script&lang=js"
import style0 from "./ChattingBlock.vue?vue&type=style&index=0&id=3a2da870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2da870",
  null
  
)

export default component.exports